document.addEventListener("DOMContentLoaded", function () {
  const lazyBackgrounds = document.querySelectorAll(".lazy-bg");

  lazyBackgrounds.forEach((element) => {
    const lazyObserver = new IntersectionObserver((entries, observer) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.style.backgroundImage = `url(${entry.target.dataset.src})`;
          lazyObserver.unobserve(entry.target);
        }
      });
    });
    lazyObserver.observe(element);
  });
});
